(() => {
  function init(section) {
    const toggle = section.querySelector('[data-cprp-toggle]');
    if (toggle) {
      const label = toggle.querySelector('.cprp-toggle-btn__label');
      const updateLabel = () => {
        const isHidden = section.classList.contains('cprp-filters-hidden');
        if (label) {
          label.textContent = isHidden ? 'Show Filters' : 'Hide Filters';
        }
        toggle.setAttribute('aria-pressed', isHidden ? 'false' : 'true');
      };

      updateLabel();

      toggle.addEventListener('click', () => {
        section.classList.toggle('cprp-filters-hidden');
        updateLabel();
      });
    }

    const setGroupHeight = (group, isOpen) => {
      const toggleBtn = group.querySelector('.cprp-filter-group__toggle');
      const content = group.querySelector('.cprp-filter-group__items');
      if (!toggleBtn || !content) return;

      if (isOpen) {
        content.hidden = false;
        content.style.height = `${toggleBtn.offsetHeight}px`;
      } else {
        content.style.height = '0px';
        content.hidden = true;
      }
    };

    section.querySelectorAll('.cprp-filter-group').forEach((group) => {
      const toggleBtn = group.querySelector('.cprp-filter-group__toggle');
      if (!toggleBtn) return;
      const isOpen = group.classList.contains('cprp-filter-group--open') || toggleBtn.getAttribute('aria-expanded') === 'true';
      setGroupHeight(group, isOpen);

      toggleBtn.addEventListener('click', () => {
        const nextOpen = !group.classList.contains('cprp-filter-group--open');
        group.classList.toggle('cprp-filter-group--open', nextOpen);
        toggleBtn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
        setGroupHeight(group, nextOpen);
      });
    });

    const headerToggle = section.querySelector('[data-cprp-header-toggle]');
    const headerContent = section.querySelector('[data-cprp-header-content]');
    if (headerToggle && headerContent) {
      headerToggle.addEventListener('click', () => {
        const header = headerToggle.closest('.cprp-filters__header');
        const isOpen = header?.classList.toggle('cprp-filters__header--open');
        headerToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        headerContent.toggleAttribute('hidden', !isOpen);
      });
    }

    const sortToggle = section.querySelector('[data-cprp-sort-toggle]');
    const sortMenu = section.querySelector('[data-cprp-sort-menu]');
    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', () => {
        const isOpen = sortToggle.classList.toggle('cprp-sort--open');
        sortToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        sortMenu.toggleAttribute('hidden', !isOpen);
      });
    }

    const refreshSwatches = () => {
      section.querySelectorAll('[data-cprp-swatches]').forEach((container) => {
        const swatches = Array.from(container.querySelectorAll('[data-cprp-swatch]'));
        const more = container.querySelector('[data-cprp-swatch-more]');
        const total = parseInt(container.dataset.count || swatches.length, 10);
        if (!swatches.length || !more) return;

        swatches.forEach((swatch) => {
          swatch.style.display = 'inline-flex';
        });
        more.style.display = 'inline-flex';

        const containerWidth = container.clientWidth;
        if (!containerWidth) return;

        const swatchRect = swatches[0].getBoundingClientRect();
        const moreRect = more.getBoundingClientRect();
        const gap = parseFloat(getComputedStyle(container).gap || '0');
        const swatchWidth = swatchRect.width;
        const moreWidth = moreRect.width;

        const maxVisible = Math.max(0, Math.floor((containerWidth - moreWidth) / (swatchWidth + gap)));
        const visibleCount = Math.min(swatches.length, maxVisible);
        const hiddenCount = Math.max(0, total - visibleCount);

        swatches.forEach((swatch, index) => {
          swatch.style.display = index < visibleCount ? 'inline-flex' : 'none';
        });

        if (hiddenCount > 0) {
          more.textContent = `+${hiddenCount}`;
          more.style.display = 'inline-flex';
        } else {
          more.style.display = 'none';
        }
      });
    };

    const refreshTitleHeights = () => {
      const cards = Array.from(section.querySelectorAll('.cprp-card'));
      if (!cards.length) return;

      const titles = cards.map((card) => card.querySelector('.cprp-card__title'));
      titles.forEach((title) => {
        if (title) title.style.minHeight = 'auto';
      });

      const rows = new Map();
      cards.forEach((card) => {
        const title = card.querySelector('.cprp-card__title');
        if (!title) return;
        const top = card.offsetTop;
        if (!rows.has(top)) rows.set(top, []);
        rows.get(top).push(title);
      });

      rows.forEach((rowTitles) => {
        let max = 0;
        rowTitles.forEach((title) => {
          max = Math.max(max, title.offsetHeight);
        });
        rowTitles.forEach((title) => {
          title.style.minHeight = `${max}px`;
        });
      });
    };

    refreshSwatches();
    refreshTitleHeights();
    window.addEventListener('resize', () => {
      refreshSwatches();
      refreshTitleHeights();
    });

    const mobileToggle = section.querySelector('[data-cprp-mobile-toggle]');
    const mobilePanel = section.querySelector('.cprp-mobile-panel');
    const mobileClose = section.querySelector('[data-cprp-mobile-close]');
    if (mobileToggle && mobilePanel) {
      const mobileLabel = mobileToggle.querySelector('.cprp-toggle-btn__label');
      const setMobileState = (open) => {
        mobilePanel.hidden = !open;
        mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (mobileLabel) {
          mobileLabel.textContent = open ? 'Hide Filters' : 'Filter & Sort';
        }
        section.classList.toggle('cprp-mobile-open', open);
      };

      setMobileState(false);

      mobileToggle.addEventListener('click', () => {
        setMobileState(mobilePanel.hidden);
      });

      if (mobileClose) {
        mobileClose.addEventListener('click', () => setMobileState(false));
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.collection-page-redesign-prototype').forEach(init);
  });
})();
